import { NgModule } from '@angular/core';
import { AuthRoutingModule } from './auth-routing.module';

import { LoginComponent } from './login/login.component';
import { ResetComponent } from './reset/reset.component';
import { ForgetComponent } from './forget/forget.component';
import { SetpasswordComponent } from './setpassword/setpassword.component';
import { ChangepasswordComponent } from './changePassword/changepassword.component';
import { LayoutComponent } from './layout/layout.component';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';  

import { NzGridModule } from 'ng-zorro-antd/grid';
import { ReactiveFormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzFormModule } from 'ng-zorro-antd/form';
import { ZohoModule } from '../zoho-salesiq/zoho.module';
import { SignupComponent } from './signup/signup.component';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { SidepanelModule } from '../components/sidepanel/sidepanel.module';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { ExistingAccountComponent } from './existing-account/existing-account.component';
import { NewBusinessComponent } from './new-business/new-business.component';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzIconModule } from 'ng-zorro-antd/icon';


@NgModule({
  imports: [ZohoModule, NzInputModule, AuthRoutingModule, NzGridModule, ReactiveFormsModule, NzButtonModule, NzAlertModule, HttpClientModule, CommonModule, NzTypographyModule, NzFormModule, SidepanelModule, NzSpinModule, NzNotificationModule, NzSelectModule, FormsModule, NzIconModule],
  declarations: [LayoutComponent, LoginComponent, ResetComponent, ForgetComponent, SetpasswordComponent, ChangepasswordComponent, SignupComponent, ExistingAccountComponent, NewBusinessComponent]
})
export class AuthModule { }